<template>
	<div class="award">
		<div v-if="obj.user_id">
			<img class="bg bg-mian" src="https://image.soole.com.cn/2020130906.png" alt="">
			<div class="awa-box">
				<div class="awa-img">
					<img class="bg" src="https://image.soole.com.cn/2020130905.png" alt="">
					<!-- 一等奖 -->
					<div class="awa-item">
						<div>恭喜您抽中{{
							obj.prize_grade==1?"一":
							obj.prize_grade==2?"二":
							obj.prize_grade==3?"三":
							obj.prize_grade==4?"四":''
						}}等奖</div>
						<div>
							{{
								obj.prize_grade==1?"赠长虹65寸智能电视机":
								obj.prize_grade==2?"赠豪华创业电动车":
								obj.prize_grade==3?"赠搜了宝创业手机":
								obj.prize_grade==4?"赠美的电饭锅":''
							}}
						</div>
						<div>
							<img :src="`https://image.soole.com.cn/${
								obj.prize_grade==1?'2020130907':
								obj.prize_grade==2?'2020130910':
								obj.prize_grade==3?'20201309010':
								obj.prize_grade==4?'20201219111557':''}.png`" alt="">
						</div>
						<div>ID：{{obj.userId}}</div>
					</div>
					<!-- 二等奖 -->
					<!-- 三等奖 -->
					<!-- 未中奖 -->
				</div>
			</div>
		</div>
		<div class="no-awa" v-else>
			<div class="a-box">
				<div class="pop">
					<div>很遗憾，这次您没有中奖～</div>
					<div>期待您的下一次参与!</div>
					<div>ID:{{obj.userId}}</div>
					<div>
						<img src="https://image.soole.com.cn/2020130908.png" alt="">
					</div>
				</div>
				<div class="clear" @click="back">
					<img src="https://image.soole.com.cn/2020130909.png" alt="">
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				key: 1,
				obj:''
			}
		},
		created() {
			this.obj = this.$route.query.obj;
			
		},
		mounted() {
			document.querySelector('title').innerText = '中奖查询';
		},
		methods:{
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style lang="less">
	.award{
		position: relative;
		.bg{
			width: 100%;
		}
		.bg-mian{
			height: 100vh;
		}
		.awa-box{
			width: 100%;
			position: absolute;
			top: 25%;
			left:25%;
			right: 0;
			bottom: 0;
			margin: -25%  auto auto -25%;
		}
		.awa-img{
			width: 17.625rem;
			margin: auto;
			position:relative;
		}
		.awa-item{
			position: absolute;
			width: 100%;
			top: 4.0625rem;
			margin: auto;
			text-align: center;
			color: #FFFFFF;
			&>div:nth-child(1){
				color: #9A5812;
				font-size: 1.125rem;
				font-weight: 700;
				margin-bottom: 2.375rem;
			}
			&>div:nth-child(2){
				font-size: 0.9375rem;
				margin-bottom: 1.5625rem;
			}
			&>div:nth-child(3){
				margin-bottom: 1.375rem;
				img{
					width: 12.5rem;
					max-height: 8.125rem;
				}
			}
			&>div:nth-child(4){
				font-size: 1.0625rem;
			}
		}
		.no-awa{
			background-color: #5F5F5F;
			height: 100vh;
			position: relative;
			.a-box{
				// width: 100%;
				
				position: absolute;
				top: 25%;
				left:1.25rem;
				right: 1.25rem;
				bottom: 25%;
				.clear{
					width: 100%;
					text-align: center;
					margin-top: 1.2rem;
				}
				.clear img{
					margin: auto;
					width:2.5rem;
					height: 2.5rem;
				}
				
				.pop{
					border-radius: 0.3125rem;
					background-color: #FFFFFF;
					text-align: center;
					&>div:nth-child(1){
						color: #333333;
						font-weight: 700;
						font-size: 1.125rem;
						padding: 1.0625rem 0;
					}
					&>div:nth-child(2){
						color: #666;
						margin-bottom: 0.75rem;
						font-size: 0.875rem;
					}
					&>div:nth-child(3){
						color: #FF9539;
						margin-bottom: 2.0625rem;
						font-size: 0.875rem;
					}
					&>div:nth-child(4){
						padding-bottom: 1.875rem;
						img{
							margin: auto;
							width: 12.5rem;
							max-height: 8.1875rem;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/annualMeeting/award.vue